import { useEffect, useState } from 'react'
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import axios from 'axios'
// Enable Pusher logging for debugging (highly recommended)
Pusher.logToConsole = true;

// Fix: Initialize Pusher outside of React lifecycle
if (typeof window !== 'undefined' && !window.Pusher) {
    window.Pusher = Pusher
}

const useEcho = () => {
    const [echoInstance, setEchoInstance] = useState(null)
    const [isConnected, setIsConnected] = useState(false); // Add isConnected state for better debugging

    useEffect(() => {
        console.log("[useEcho] Initializing Echo instance...");

        const echo = new Echo({
            broadcaster: 'reverb',
            key: process.env.REACT_APP_REVERB_APP_KEY,
            authorizer: channel => {
                console.log(`[Authorizer] Called for channel: ${channel.name}`);
                return {
                    authorize: (socketId, callback) => {
                        console.log(`[Authorize] Attempting to authorize channel: ${channel.name} with socketId: ${socketId}`);

                        const SOCKET_AUTHORIZATION_URL = process.env.REACT_APP_SOCKET_AUTHORIZATION_URL;

                        // --- THE KEY CHANGE IS HERE ---
                        const authData = new URLSearchParams();
                        authData.append('socket_id', socketId);
                        authData.append('channel_name', channel.name);

                        // Ensure your 'api' (Axios instance) is configured to send
                        // Content-Type: application/x-www-form-urlencoded
                        // Axios generally handles this automatically if you pass URLSearchParams
                        // However, if your 'api' instance overrides headers, be careful.
                        axios.post(SOCKET_AUTHORIZATION_URL, authData, {
                            // Optional: If your 'api' instance has default headers, you might need to
                            // explicitly set the content type, though URLSearchParams usually hints Axios
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                                // Include any other headers like Authorization if your 'api' instance doesn't add them by default
                                'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                            },
                            // Add withCredentials: true if you are relying on session cookies (e.g., Sanctum SPA auth)
                            withCredentials: true,
                        })
                        .then(response => {
                            console.log("[Authorize] Success:", response.data);
                            callback(false, response.data); // callback(error, authData)
                        })
                        .catch(error => {
                            console.error("[Authorize] Error:", error.response?.status, error.response?.data || error.message);
                            callback(true, error.response?.data || error); // callback(error, errorData)
                        });
                    },
                };
            },
            wsHost: process.env.REACT_APP_REVERB_HOST,
            wsPort: process.env.REACT_APP_REVERB_PORT,
            wssPort: process.env.REACT_APP_REVERB_PORT,
            forceTLS: (process.env.REACT_APP_REVERB_SCHEME ?? 'https') === 'https',
            enabledTransports: ['ws', 'wss'],
        });

        // Add connection status logging for Reverb itself
        echo.connector.pusher.connection.bind('connected', () => {
            console.log('[Echo Status] Connected to Reverb WebSocket!');
            setIsConnected(true);
        });
        echo.connector.pusher.connection.bind('disconnected', () => {
            console.log('[Echo Status] Disconnected from Reverb WebSocket!');
            setIsConnected(false);
        });
        echo.connector.pusher.connection.bind('error', (err) => {
            console.error('[Echo Status] Reverb Connection Error:', err);
            if (err.data) console.error("Reverb Error Data:", err.data);
        });


        setEchoInstance(echo);

        // Cleanup Echo instance
        return () => {
            console.log("[useEcho] Cleaning up Echo instance.");
            echo.disconnect();
        };
    }, []); // Empty dependency array means this runs once on mount
    return echoInstance;
};

export default useEcho;